export default class HtmlElementBuilder {
	private readonly element: HTMLElement;

	constructor(tagName: string) {
		this.element = document.createElement(tagName);
	}

	public setId(id: string): HtmlElementBuilder {
		this.element.id = id;
		return this;
	}

	public addLabel(label: string): HtmlElementBuilder {
		this.element.textContent = label;
		return this;
	}

	public addClass(classNames: string): HtmlElementBuilder {
		classNames.split(' ').forEach((className: string) => {
			this.element.classList.add(className);
		});
		return this;
	}

	public removeClass(classNames: string): HtmlElementBuilder {
		classNames.split(' ').forEach((className: string) => {
			this.element.classList.remove(className);
		});
		return this;
	}

	public addAttr(attrName: string, attrValue: string): HtmlElementBuilder {
		this.element.setAttribute(attrName, attrValue);
		return this;
	}

	public onClick = (callback: () => void): HtmlElementBuilder => {
		this.element.addEventListener('click', callback);
		return this;
	}

	public append(htmlElement: HTMLElement): HtmlElementBuilder {
		this.element.appendChild(htmlElement);
		return this;
	}

	public prepend(htmlElement: HTMLElement): HtmlElementBuilder {
		this.element.prepend(htmlElement);
		return this;
	}

	public build<T extends HTMLElement = HTMLElement>(): T {
		return this.element as T;
	}
}